import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";
import { articles } from "@/mocks/articles";

export default function FeaturedSection() {
  const sorted = [...articles].sort((a, b) => b.hot - a.hot);
  const lead = sorted[0];
  const rest = sorted.slice(1, 4);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-50">
      <SectionHeading
        eyebrow="主编精选"
        title="今日必看的几个大瓜"
        desc="编辑从当日热点里挑出的高讨论度现场，脉络清晰、进展完整，适合一次看明白。"
      />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
        <ArticleCard article={lead} variant="wide" />
        <div className="flex flex-col gap-3 md:gap-4">
          {rest.map((article) => (
            <ArticleCard key={article.id} article={article} variant="row" />
          ))}
          <div className="hidden lg:flex items-center gap-2 text-sm text-foreground-400 px-1">
            <i className="ri-lightbulb-line text-accent-600" aria-hidden="true"></i>
            每天上午 9:00 与晚上 21:00 各更新一次精选
          </div>
        </div>
      </div>
    </section>
  );
}